<script>
import service from '@/service';
import _ from 'lodash';
import { parse } from 'date-fns';
import settings from '@/settings.js';

export default {
	methods: {
		showModal: function (priliv, readOnly) {
			this.clearForm();
			this.readOnly = readOnly;
			if (!priliv) {
				this.addNew = true;
				this.clearForm();
				this.$refs.modal.show();
			} else {
				this.modalPriliv.id = priliv.id;
				this.modalPriliv.id_vozila = priliv.id_vozila;
				if (priliv.datum) {
					this.modalPriliv.datum = parse(priliv.datum, settings.dbDtFormat);
				}
				this.modalPriliv.naziv = priliv.naziv;
				this.modalPriliv.referenca = priliv.referenca;
				this.modalPriliv.znesek = Number(priliv.znesek);
				this.modalPriliv.placnik = priliv.placnik;
				this.modalPriliv.ogrodje = priliv.ogrodje;
				this.$refs.modal.show();
			}
		},
		modal_okClick: function (evt) {
			evt.preventDefault();
			service.addPriliv(this.modalPriliv)
				.then(response => {
					if (this.addNew) {
						this.$emit('priliv_add');
					} else {
						this.$emit('priliv_edit');
					}
					this.$refs.modal.hide();
					this.clearForm();
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
				});
		},
		modal_cancelClick: function (evt) {
			evt.preventDefault();
			this.clearForm();
			this.$refs.modal.hide();
			setTimeout(() => {
				this.clearForm();
			}, 300);
		},
		showError: function (message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		clearForm: function () {
			this.addNew = false;
			this.modalPriliv.id = 0;
			this.modalPriliv.datum = null;
			this.modalPriliv.id_vozila = null;
			this.modalPriliv.naziv = '';
			this.modalPriliv.referenca = '';
			this.modalPriliv.znesek = 0;
			this.modalPriliv.placnik = '';
			this.modalPriliv.ogrodje = null;
			this.readOnly = false;
		},
		vozilaSelect_load: _.debounce((loading, search, vm) => {
			loading(true);
			service.searchVozila(search)
				.then(vozila => {
					loading(false);
					vm.ogrodja_options = vozila;
				})
				.catch(error => {
					loading(false);
					if (error) {
						console.log(error);
					}
				});
		}, 500),
		voziloSelect_change: function (value) {
			this.modalPriliv.id_vozila = value.id;
		},
		vozilaSelect_search: function (search, loading) {
			if (search && search !== '') {
				this.vozilaSelect_load(loading, search, this);
			}
		}
	},
	watch: {
	},
	data: function () {
		return {
			modalTitle: '',
			modalCancelTitle: 'Prekliči',
			modalErrorMsg: null,
			modalIsBusy: false,
			addNew: false,
			modalPriliv: {
				id: 0,
				datum: null,
				naziv: '',
				referenca: '',
				znesek: 0,
				placnik: '',
				ogrodje: null
			},
			ogrodja_options: [],
			readOnly: false
		}
	},
	computed: {
		modalTitle_text () {
			if (this.readOnly) {
				return 'Podrobnosti priliva';
			} else if (this.modalPriliv.id === 0) {
				return 'Dodajanje priliva';
			}
			return 'Urejanje priliva';
		},
		ok_text () {
			if (this.readOnly) {
				return 'OK';
			} else if (this.modalPriliv.id === 0) {
				return 'Dodaj';
			}
			return 'Shrani';
		},
		message_class () {
			if (this.show_step_two) {
				return 'error_message_b';
			}
			return 'error_message';
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" class="modal-primary" @ok="modal_okClick" :title="modalTitle_text" :ok-title="ok_text" :cancel-title="modalCancelTitle" :busy="modalIsBusy">
		<b-form ref="form" novalidate>
			<app-mbox v-if="modalErrorMsg" :text="modalErrorMsg.message" @dismissed="clear_error_msg"></app-mbox>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-horizontal"
						label-cols="2"
						label="Datum"
						label-for="datum">
						<v-date-picker v-if="modalPriliv.id >= 0 && !readOnly"
							ref="datum"
							id="datum"
							:max-date="new Date(Date.now())"
							v-model="modalPriliv.datum"
							:is-required="true"
							:input-props='{
								class: "form-control dt_border gdt_border",
								placeholder: "DD. MM. YYYY",
								required: true
							}'
							mode="single"
							locale="sl-SI"/>
						<b-form-input id="datum" v-else type="text" :value="modalPriliv.datum | hr_date" :disabled="readOnly"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Naziv"
						label-cols="2"
						label="Naziv"
						label-for="naziv">
						<b-form-input type="text" id="naziv" v-model="modalPriliv.naziv" :disabled="readOnly"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Referenca"
						label-cols="2"
						label="Referenca"
						label-for="referenca">
						<b-form-input type="text" id="referenca" v-model="modalPriliv.referenca" :disabled="readOnly"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Znesek"
						label-cols="2"
						label="Znesek"
						label-for="znesek">
						<currency-input class="form-control" type="text" id="znesek" v-model="modalPriliv.znesek" :disabled="readOnly"></currency-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Placnik"
						label-cols="2"
						label="Placnik"
						label-for="placnik">
						<b-form-input type="text" id="placnik" v-model="modalPriliv.placnik" :disabled="readOnly"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Ogrodje"
						label-cols="2"
						label="Ogrodje"
						label-for="ogrodje">
						<v-select v-model="modalPriliv.ogrodje"
							id="ogrodje" 
							label="ogrodje"
							:options="ogrodja_options"
							:taggable="true"
							:filterable="false"
							@input="voziloSelect_change($event)"
							@search="vozilaSelect_search"
							placeholder="Izberi vozilo ..."
							:disabled="readOnly">
							<template slot="no-options">Vnesite VIN številko vozila</template>
					</v-select>
					</b-form-group>
				</b-col>
			</b-row>
		</b-form>
	</b-modal>
</template>
<style scoped>
@import '../../../node_modules/ladda/dist/ladda-themeless.min.css';

.b_table {
	margin-bottom: o;
}
.ma_pos {
	text-align: end;
}
.noVIN {
	background-color: tomato;
}
.error_message {
	margin-top: 1rem;
	margin-bottom: 0;
}
.error_message_b {
	margin: 1rem;
}
</style>
<style>
.no_padding {
	padding: 0;
	margin: 0;
}
.custom-file-input ~ .custom-file-label::after {
	content: 'Izberi';
}
</style>


// WEBPACK FOOTER //
// src/components/Modals/EditPrilivModal.vue